import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'

export const BonusBetListContainerStyled = styled.div({
  margin: `0 -${spacing.sm}`,
  overflow: 'auto',
})

export const BonusBetListItemContainerStyled = styled.div({
  margin: `0 ${spacing.sm}`,
  overflow: 'auto',
})
